export const contractAddress =
	"erd1qqqqqqqqqqqqqpgqydyf2eegnzhedmfysamk035d9hwrk26adn3qcdk82p";

export const dAppName = "Tortuga Staking Voting";

export const apiAddress = "https://api.elrond.com";

export const apiTimeout = 6000;
export const transactionSize = 15;
